import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { getOwner as _$getOwner } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<span class=tzr-pill>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=tzr-read><header class=tzr-read-header><div class=tzr-read-title> — <small></small></div><span></span><button type=button class=tzr-x>✕</button></header><div class=tzr-read-tabs><div class=tzr-read-tab></div><div class=tzr-read-tab> <span class=n></span></div><div class=tzr-read-tab> <span class=n></span></div></div><div class=tzr-read-body></div><footer class=tzr-read-actions>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<button type=button>`),
  _tmpl$4 = /*#__PURE__*/_$template(`<span class=tzr-code>`),
  _tmpl$5 = /*#__PURE__*/_$template(`<img class=tzr-detail-thumb alt>`),
  _tmpl$6 = /*#__PURE__*/_$template(`<div class=tzr-detail-grid><dl class=tzr-kv>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<dt>`),
  _tmpl$8 = /*#__PURE__*/_$template(`<dd>`),
  _tmpl$9 = /*#__PURE__*/_$template(`<dt>GPS`),
  _tmpl$0 = /*#__PURE__*/_$template(`<dd>, `),
  _tmpl$1 = /*#__PURE__*/_$template(`<div class=tzr-read-section><h3></h3><dl class=tzr-kv>`),
  _tmpl$10 = /*#__PURE__*/_$template(`<dd class=mono>`),
  _tmpl$11 = /*#__PURE__*/_$template(`<dd> kB`),
  _tmpl$12 = /*#__PURE__*/_$template(`<div class=tzr-errbox>⚠ `),
  _tmpl$13 = /*#__PURE__*/_$template(`<div class=tzr-read-section><h3>`),
  _tmpl$14 = /*#__PURE__*/_$template(`<div class=tzr-warnbox>⚠ `),
  _tmpl$15 = /*#__PURE__*/_$template(`<figure><img alt><figcaption><span></span><span class=tzr-caption-name>`),
  _tmpl$16 = /*#__PURE__*/_$template(`<figure><img class=lp alt><figcaption><span></span><span class=tzr-caption-name>`),
  _tmpl$17 = /*#__PURE__*/_$template(`<figure class=txtcard><details><summary>📄 </summary><pre></pre></details><figcaption><span></span><span class=tzr-caption-name>`),
  _tmpl$18 = /*#__PURE__*/_$template(`<div class=tzr-photos>`),
  _tmpl$19 = /*#__PURE__*/_$template(`<button type=button class="tzr-btn tzr-download"><mele-image icon=server.download>`, true, false, false),
  _tmpl$20 = /*#__PURE__*/_$template(`<img>`),
  _tmpl$21 = /*#__PURE__*/_$template(`<figure><div class=tzr-file-row><span> </span></div><figcaption><span></span><span> kB`),
  _tmpl$22 = /*#__PURE__*/_$template(`<dl class=tzr-wfid><dt></dt><dd> (<!>)</dd><dt></dt><dd>`),
  _tmpl$23 = /*#__PURE__*/_$template(`<div class=tzr-timeline>`),
  _tmpl$24 = /*#__PURE__*/_$template(`<div class=tzr-hint>`),
  _tmpl$25 = /*#__PURE__*/_$template(`<span>: <!> → <b>`),
  _tmpl$26 = /*#__PURE__*/_$template(`<div><div class=tzr-log-head><span class=tzr-log-action></span><span class=tzr-log-dt></span><span class=tzr-log-actor></span></div><div class=tzr-log-diff>`),
  _tmpl$27 = /*#__PURE__*/_$template(`<span>`),
  _tmpl$28 = /*#__PURE__*/_$template(`<span> · <!>: <b>`);
/**
 * The record detail drawer — tabs Detail / Fotografie / História, workflow action buttons
 * in the footer (design source: tmp/tzrecords-detail-mock.html).
 */

import { For, Show, createSignal, onMount } from 'solid-js';
import { useWorkflow, ACTION_CLASS } from 'mmodSolidWorkflow';
import { fmtDt } from 'mmodSolidModule/datetime';
import { STATE_TONES } from './constants';

// actions invoked from dedicated UI (files tab, wizard), never rendered as footer buttons
const PROGRAMMATIC_ACTIONS = new Set(['GET_FILE', 'ATTACH', 'DETACH', 'SET_MAIN_PHOTO']);

// log columns + heavy/internal fields never shown in the history diff lines
const LOG_HIDDEN = new Set(['id', 'log_id', 'log_dt', 'log_sent', 'log_action', 'log_state1', 'log_state2', 'log_apptype', 'log_appid', 'log_listenerid', 'log_requestid', 'log_status', 'log_ip', 'log_userid', 'log_login', 'log_callsign', 'log_unitid', 'created_dt', 'updated_dt', 'state', 'roles', 'jpeg', 'jpeg2', 'jpeg3', 'lpjpeg', 'lpcrop', 'meta', 'meta_binary', 'meta_name', 'photo_name', 'photo_width', 'photo_height', 'parse_warnings', 'import_app_id', 'import_user_id', 'import_login', 'export', '_limited', '_actions', '_form', '_logs']);
export function ReadPanel(props) {
  const {
    setStore,
    module: m,
    tr,
    client,
    actionColor
  } = useWorkflow();
  const record = () => props.record;
  const [tab, setTab] = createSignal('detail');
  const logs = () => _.orderBy(record()._logs || [], [log => Number(log.log_dt)], ['desc']);
  const photo_count = () => ['jpeg', 'lpjpeg', 'meta'].filter(key => record()[key]).length + (record().attachments || []).length;
  return (() => {
    var _el$ = _tmpl$2(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.firstChild,
      _el$5 = _el$4.nextSibling,
      _el$7 = _el$3.nextSibling,
      _el$8 = _el$7.nextSibling,
      _el$9 = _el$2.nextSibling,
      _el$0 = _el$9.firstChild,
      _el$1 = _el$0.nextSibling,
      _el$10 = _el$1.firstChild,
      _el$11 = _el$10.nextSibling,
      _el$12 = _el$1.nextSibling,
      _el$13 = _el$12.firstChild,
      _el$14 = _el$13.nextSibling,
      _el$15 = _el$9.nextSibling,
      _el$16 = _el$15.nextSibling;
    _$insert(_el$3, () => tr('detail.Title'), _el$4);
    _$insert(_el$3, () => record().lpnumber || record().device_id || record().id, _el$5);
    _$insert(_el$5, () => record().id);
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return record().cleaned_dt;
      },
      get children() {
        var _el$6 = _tmpl$();
        _$insert(_el$6, () => tr('detail.Cleaned'));
        _$effect(() => _$setAttribute(_el$6, "title", fmtDt(record().cleaned_dt)));
        return _el$6;
      }
    }), _el$7);
    _$insert(_el$7, () => tr(`state.${record().state}`));
    _el$8.$$click = () => setStore('selected', '');
    _el$0.$$click = () => setTab('detail');
    _$insert(_el$0, () => tr('detail.TabDetail'));
    _el$1.$$click = () => setTab('photos');
    _$insert(_el$1, () => tr('detail.TabPhotos'), _el$10);
    _$insert(_el$11, photo_count);
    _el$12.$$click = () => setTab('history');
    _$insert(_el$12, () => tr('detail.TabHistory'), _el$13);
    _$insert(_el$14, () => logs().length);
    _$insert(_el$15, _$createComponent(Show, {
      get when() {
        return tab() === 'detail';
      },
      get children() {
        return _$createComponent(DetailTab, {
          get record() {
            return record();
          }
        });
      }
    }), null);
    _$insert(_el$15, _$createComponent(Show, {
      get when() {
        return tab() === 'photos';
      },
      get children() {
        return _$createComponent(PhotosTab, {
          get record() {
            return record();
          }
        });
      }
    }), null);
    _$insert(_el$15, _$createComponent(Show, {
      get when() {
        return tab() === 'history';
      },
      get children() {
        return _$createComponent(HistoryTab, {
          get record() {
            return record();
          },
          get logs() {
            return logs();
          }
        });
      }
    }), null);
    _$insert(_el$16, _$createComponent(For, {
      get each() {
        return client.actionsFor(record()).filter(action => !PROGRAMMATIC_ACTIONS.has(action));
      },
      children: action => (() => {
        var _el$17 = _tmpl$3();
        _el$17.$$click = () => m.runAction(record(), action);
        _$insert(_el$17, () => tr(`action.${action}`));
        _$effect(() => _$className(_el$17, `tzr-btn ${ACTION_CLASS[actionColor(record(), action)] || ''}`));
        return _el$17;
      })()
    }));
    _$effect(_p$ => {
      var _v$ = `tzr-pill ${STATE_TONES[record().state] || ''}`,
        _v$2 = !!(tab() === 'detail'),
        _v$3 = !!(tab() === 'photos'),
        _v$4 = !!(tab() === 'history');
      _v$ !== _p$.e && _$className(_el$7, _p$.e = _v$);
      _v$2 !== _p$.t && _el$0.classList.toggle("active", _p$.t = _v$2);
      _v$3 !== _p$.a && _el$1.classList.toggle("active", _p$.a = _v$3);
      _v$4 !== _p$.o && _el$12.classList.toggle("active", _p$.o = _v$4);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined
    });
    return _el$;
  })();
}
function DetailTab(props) {
  const {
    store,
    setStore,
    t,
    tr,
    tx
  } = useWorkflow();
  const r = () => props.record;
  const geocode = () => store.detail_geocode;
  const main_rows = () => [['device_id', `${r().device_id || '—'} (${r().device_type || '—'})`], ['type', r().type ? tr(`violation.${r().type}`) : null], ['event_dt', fmtDt(r().event_dt)], ['speed_kmh', r().speed_kmh != null ? `${r().speed_kmh} km/h` : null], ['speed_limit', r().speed_limit != null ? `${r().speed_limit} km/h` : null], ['lpnumber', r().lpnumber ? `${r().lpnumber} (${r().lpcountry || '—'})` : null], ['license_plate_number_confidence', r().license_plate_number_confidence], ['country_code_confidence', r().country_code_confidence], ['lane', r().lane], ['employee_num', r().employee_num]].filter(([, value]) => value != null && value !== '');
  const territory = (code_key, name_key) => {
    var _geocode;
    const code = r()[code_key];
    const name = (_geocode = geocode()) === null || _geocode === void 0 ? void 0 : _geocode[name_key];
    if (!code && !name) return null;
    return [name || '—', " ", (() => {
      var _el$18 = _tmpl$4();
      _$insert(_el$18, () => {
        var _geocode2;
        return code || ((_geocode2 = geocode()) === null || _geocode2 === void 0 ? void 0 : _geocode2[code_key]);
      });
      return _el$18;
    })()];
  };
  return [(() => {
    var _el$19 = _tmpl$6(),
      _el$21 = _el$19.firstChild;
    _$insert(_el$19, _$createComponent(Show, {
      get when() {
        return r().jpeg2 || r().jpeg;
      },
      get children() {
        var _el$20 = _tmpl$5();
        _el$20.$$click = () => setStore('lightbox', r().jpeg || r().jpeg2);
        _$effect(() => _$setAttribute(_el$20, "src", r().jpeg2 || r().jpeg));
        return _el$20;
      }
    }), _el$21);
    _$insert(_el$21, _$createComponent(For, {
      get each() {
        return main_rows();
      },
      children: ([key, value]) => [(() => {
        var _el$54 = _tmpl$7();
        _$insert(_el$54, () => tr(key));
        return _el$54;
      })(), (() => {
        var _el$55 = _tmpl$8();
        _$insert(_el$55, value);
        return _el$55;
      })()]
    }));
    return _el$19;
  })(), (() => {
    var _el$22 = _tmpl$1(),
      _el$23 = _el$22.firstChild,
      _el$24 = _el$23.nextSibling;
    _$insert(_el$23, () => tr('detail.Location'));
    _$insert(_el$24, _$createComponent(Show, {
      get when() {
        return r().locality;
      },
      get children() {
        return [(() => {
          var _el$25 = _tmpl$7();
          _$insert(_el$25, () => tr('locality'));
          return _el$25;
        })(), (() => {
          var _el$26 = _tmpl$8();
          _$insert(_el$26, () => r().locality);
          return _el$26;
        })()];
      }
    }), null);
    _$insert(_el$24, _$createComponent(Show, {
      get when() {
        return r().context;
      },
      get children() {
        return [(() => {
          var _el$27 = _tmpl$7();
          _$insert(_el$27, () => tr('context'));
          return _el$27;
        })(), (() => {
          var _el$28 = _tmpl$8();
          _$insert(_el$28, () => t(`delict.context.${r().context}`));
          return _el$28;
        })()];
      }
    }), null);
    _$insert(_el$24, _$createComponent(Show, {
      get when() {
        return r().gps_lat != null;
      },
      get children() {
        return [_tmpl$9(), (() => {
          var _el$30 = _tmpl$0(),
            _el$31 = _el$30.firstChild;
          _$insert(_el$30, () => r().gps_lat, _el$31);
          _$insert(_el$30, () => r().gps_lon, null);
          return _el$30;
        })()];
      }
    }), null);
    _$insert(_el$24, _$createComponent(Show, {
      get when() {
        return territory('region_code', 'region_name');
      },
      get children() {
        return [(() => {
          var _el$32 = _tmpl$7();
          _$insert(_el$32, () => tr('region_code'));
          return _el$32;
        })(), (() => {
          var _el$33 = _tmpl$8();
          _$insert(_el$33, () => territory('region_code', 'region_name'));
          return _el$33;
        })()];
      }
    }), null);
    _$insert(_el$24, _$createComponent(Show, {
      get when() {
        return territory('district_code', 'district_name');
      },
      get children() {
        return [(() => {
          var _el$34 = _tmpl$7();
          _$insert(_el$34, () => tr('district_code'));
          return _el$34;
        })(), (() => {
          var _el$35 = _tmpl$8();
          _$insert(_el$35, () => territory('district_code', 'district_name'));
          return _el$35;
        })()];
      }
    }), null);
    _$insert(_el$24, _$createComponent(Show, {
      get when() {
        return territory('municipality_code', 'municipality_name');
      },
      get children() {
        return [(() => {
          var _el$36 = _tmpl$7();
          _$insert(_el$36, () => tr('municipality_code'));
          return _el$36;
        })(), (() => {
          var _el$37 = _tmpl$8();
          _$insert(_el$37, () => territory('municipality_code', 'municipality_name'));
          return _el$37;
        })()];
      }
    }), null);
    return _el$22;
  })(), _$createComponent(Show, {
    get when() {
      return r().passage_id || r().forward_dt || r().forward_error || r().error;
    },
    get children() {
      var _el$38 = _tmpl$1(),
        _el$39 = _el$38.firstChild,
        _el$40 = _el$39.nextSibling;
      _$insert(_el$39, () => tr('detail.Transfer'));
      _$insert(_el$40, _$createComponent(Show, {
        get when() {
          return r().passage_id;
        },
        get children() {
          return [(() => {
            var _el$41 = _tmpl$7();
            _$insert(_el$41, () => tr('passage_id'));
            return _el$41;
          })(), (() => {
            var _el$42 = _tmpl$10();
            _$insert(_el$42, () => r().passage_id);
            return _el$42;
          })()];
        }
      }), null);
      _$insert(_el$40, _$createComponent(Show, {
        get when() {
          return r().forward_dt;
        },
        get children() {
          return [(() => {
            var _el$43 = _tmpl$7();
            _$insert(_el$43, () => tr('forward_dt'));
            return _el$43;
          })(), (() => {
            var _el$44 = _tmpl$8();
            _$insert(_el$44, () => fmtDt(r().forward_dt));
            return _el$44;
          })()];
        }
      }), null);
      _$insert(_el$40, _$createComponent(Show, {
        get when() {
          return r().forward_size;
        },
        get children() {
          return [(() => {
            var _el$45 = _tmpl$7();
            _$insert(_el$45, () => tr('forward_size'));
            return _el$45;
          })(), (() => {
            var _el$46 = _tmpl$11(),
              _el$47 = _el$46.firstChild;
            _$insert(_el$46, () => Math.round(r().forward_size / 1024), _el$47);
            return _el$46;
          })()];
        }
      }), null);
      _$insert(_el$38, _$createComponent(Show, {
        get when() {
          return r().forward_error;
        },
        get children() {
          var _el$48 = _tmpl$12(),
            _el$49 = _el$48.firstChild;
          _$insert(_el$48, () => r().forward_error, null);
          return _el$48;
        }
      }), null);
      _$insert(_el$38, _$createComponent(Show, {
        get when() {
          return r().error;
        },
        get children() {
          var _el$50 = _tmpl$12(),
            _el$51 = _el$50.firstChild;
          _$insert(_el$50, () => tx(r().error), null);
          return _el$50;
        }
      }), null);
      return _el$38;
    }
  }), _$createComponent(Show, {
    get when() {
      return (r().parse_warnings || []).length > 0;
    },
    get children() {
      var _el$52 = _tmpl$13(),
        _el$53 = _el$52.firstChild;
      _$insert(_el$53, () => tr('wizard.ParserWarnings'));
      _$insert(_el$52, _$createComponent(For, {
        get each() {
          return r().parse_warnings;
        },
        children: warning => (() => {
          var _el$56 = _tmpl$14(),
            _el$57 = _el$56.firstChild;
          _$insert(_el$56, () => tx(warning), null);
          return _el$56;
        })()
      }), null);
      return _el$52;
    }
  })];
}
function PhotosTab(props) {
  const {
    setStore,
    module: m,
    tr
  } = useWorkflow();
  const r = () => props.record;
  const crop_name = () => `vyrez_${r().photo_name || 'ecv.jpg'}`;
  return (() => {
    var _el$58 = _tmpl$18();
    _$insert(_el$58, _$createComponent(Show, {
      get when() {
        return r().jpeg || r().jpeg2;
      },
      get children() {
        var _el$59 = _tmpl$15(),
          _el$60 = _el$59.firstChild,
          _el$61 = _el$60.nextSibling,
          _el$62 = _el$61.firstChild,
          _el$63 = _el$62.nextSibling;
        _el$60.$$click = () => setStore('lightbox', r().jpeg || r().jpeg2);
        _$insert(_el$62, () => tr('jpeg'));
        _$insert(_el$63, () => r().photo_name, null);
        _$insert(_el$63, (() => {
          var _c$ = _$memo(() => !!r().photo_width);
          return () => _c$() ? ` · ${r().photo_width}×${r().photo_height}` : '';
        })(), null);
        _$insert(_el$61, _$createComponent(DownloadButton, {
          onClick: () => m.downloadStoredFile(r().photo_name || 'photo.jpg', 'image/jpeg', r().jpeg || r().jpeg2)
        }), null);
        _$effect(() => _$setAttribute(_el$60, "src", r().jpeg || r().jpeg2));
        return _el$59;
      }
    }), null);
    _$insert(_el$58, _$createComponent(Show, {
      get when() {
        return r().lpjpeg;
      },
      get children() {
        var _el$64 = _tmpl$16(),
          _el$65 = _el$64.firstChild,
          _el$66 = _el$65.nextSibling,
          _el$67 = _el$66.firstChild,
          _el$68 = _el$67.nextSibling;
        _el$65.$$click = () => setStore('lightbox', r().lpjpeg);
        _$insert(_el$67, () => tr('lpjpeg'));
        _$insert(_el$68, () => tr('detail.DrawnByOperator'));
        _$insert(_el$66, _$createComponent(DownloadButton, {
          onClick: () => m.downloadStoredFile(crop_name(), 'image/jpeg', r().lpjpeg)
        }), null);
        _$effect(() => _$setAttribute(_el$65, "src", r().lpjpeg));
        return _el$64;
      }
    }), null);
    _$insert(_el$58, _$createComponent(Show, {
      get when() {
        return r().meta;
      },
      get children() {
        var _el$69 = _tmpl$17(),
          _el$70 = _el$69.firstChild,
          _el$71 = _el$70.firstChild,
          _el$72 = _el$71.firstChild,
          _el$73 = _el$71.nextSibling,
          _el$74 = _el$70.nextSibling,
          _el$75 = _el$74.firstChild,
          _el$76 = _el$75.nextSibling;
        _$insert(_el$71, () => r().meta_name || tr('meta_name'), null);
        _$insert(_el$73, () => r().meta);
        _$insert(_el$75, () => tr('meta_name'));
        _$insert(_el$76, () => r().device_type);
        _$insert(_el$74, _$createComponent(DownloadButton, {
          onClick: () => m.downloadStoredFile(r().meta_name || 'metadata.txt', 'text/plain', r().meta_binary || r().meta)
        }), null);
        return _el$69;
      }
    }), null);
    _$insert(_el$58, _$createComponent(For, {
      get each() {
        return r().attachments || [];
      },
      children: file => _$createComponent(AttachmentCard, {
        get record() {
          return r();
        },
        file: file
      })
    }), null);
    return _el$58;
  })();
}
function DownloadButton(props) {
  const {
    tr
  } = useWorkflow();
  return (() => {
    var _el$77 = _tmpl$19(),
      _el$78 = _el$77.firstChild;
    _$addEventListener(_el$77, "click", props.onClick, true);
    _el$78._$owner = _$getOwner();
    _$effect(_p$ => {
      var _v$5 = tr('action.GET_FILE'),
        _v$6 = tr('action.GET_FILE');
      _v$5 !== _p$.e && _$setAttribute(_el$77, "title", _p$.e = _v$5);
      _v$6 !== _p$.t && _$setAttribute(_el$77, "aria-label", _p$.t = _v$6);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$77;
  })();
}
function AttachmentCard(props) {
  const {
    setStore,
    module: m
  } = useWorkflow();
  const [preview, setPreview] = createSignal('');
  const is_image = () => props.file.mime === 'image/jpeg';
  onMount(async () => {
    if (is_image()) setPreview(await m.readAttachedPhoto(props.record.id, props.file));
  });
  return (() => {
    var _el$79 = _tmpl$21(),
      _el$81 = _el$79.firstChild,
      _el$82 = _el$81.firstChild,
      _el$83 = _el$82.firstChild,
      _el$84 = _el$81.nextSibling,
      _el$85 = _el$84.firstChild,
      _el$86 = _el$85.nextSibling,
      _el$87 = _el$86.firstChild;
    _$insert(_el$79, _$createComponent(Show, {
      get when() {
        return _$memo(() => !!is_image())() && preview();
      },
      get children() {
        var _el$80 = _tmpl$20();
        _el$80.$$click = () => setStore('lightbox', preview());
        _$effect(_p$ => {
          var _v$7 = preview(),
            _v$8 = props.file.name;
          _v$7 !== _p$.e && _$setAttribute(_el$80, "src", _p$.e = _v$7);
          _v$8 !== _p$.t && _$setAttribute(_el$80, "alt", _p$.t = _v$8);
          return _p$;
        }, {
          e: undefined,
          t: undefined
        });
        return _el$80;
      }
    }), _el$81);
    _$insert(_el$82, () => is_image() ? '📷' : '📎', _el$83);
    _$insert(_el$82, () => props.file.name, null);
    _$insert(_el$81, _$createComponent(DownloadButton, {
      onClick: () => m.downloadFile(props.record, props.file)
    }), null);
    _$insert(_el$85, () => props.file.mime || '—');
    _$insert(_el$86, () => Math.round(props.file.size / 1024), _el$87);
    _$effect(() => _el$79.classList.toggle("txtcard", !is_image()));
    return _el$79;
  })();
}
function HistoryTab(props) {
  const {
    module: m,
    t,
    tr
  } = useWorkflow();
  const r = () => props.record;
  const userName = userid => {
    if (!userid) return '';
    const full = t(`user.fullname.${userid}`);
    return full.startsWith('user.fullname.') ? String(userid) : full;
  };
  const dotClass = log => {
    if (!log.log_state1) return 'create';
    if (log.log_state2 === 'NOTFORWARDED') return 'err';
    if (log.log_state2 === 'READY' || log.log_state2 === 'FORWARDED') return 'ok';
    return '';
  };

  /** The fields this action wrote — a log row carries only the changed columns. */
  const changes = log => {
    const parts = [];
    for (const [key, value] of Object.entries(log)) {
      if (LOG_HIDDEN.has(key) || value == null || value === '') continue;
      let shown = value;
      if (/(_dt)$/.test(key)) shown = fmtDt(value);else if (key === 'context') shown = t(`delict.context.${value}`);else if (key === 'type') shown = tr(`violation.${value}`);else if (key === 'device_type') shown = tr(`device_type.${value}`);
      parts.push([tr(key), _.toString(shown)]);
    }
    return parts.slice(0, 6);
  };
  return [(() => {
    var _el$88 = _tmpl$22(),
      _el$89 = _el$88.firstChild,
      _el$90 = _el$89.nextSibling,
      _el$91 = _el$90.firstChild,
      _el$93 = _el$91.nextSibling,
      _el$92 = _el$93.nextSibling,
      _el$94 = _el$90.nextSibling,
      _el$95 = _el$94.nextSibling;
    _$insert(_el$89, () => tr('detail.Workflow'));
    _$insert(_el$90, () => {
      var _m$wfclient$slice$mod;
      return (_m$wfclient$slice$mod = m.wfclient.slice().model) === null || _m$wfclient$slice$mod === void 0 ? void 0 : _m$wfclient$slice$mod.id;
    }, _el$91);
    _$insert(_el$90, () => m.config.workflow_server, _el$93);
    _$insert(_el$94, () => tr('id'));
    _$insert(_el$95, () => r().id);
    _$insert(_el$88, _$createComponent(Show, {
      get when() {
        return r().created_dt;
      },
      get children() {
        return [(() => {
          var _el$96 = _tmpl$7();
          _$insert(_el$96, () => tr('detail.Created'));
          return _el$96;
        })(), (() => {
          var _el$97 = _tmpl$8();
          _$insert(_el$97, () => fmtDt(r().created_dt));
          return _el$97;
        })()];
      }
    }), null);
    _$insert(_el$88, _$createComponent(Show, {
      get when() {
        return r().updated_dt;
      },
      get children() {
        return [(() => {
          var _el$98 = _tmpl$7();
          _$insert(_el$98, () => tr('detail.Updated'));
          return _el$98;
        })(), (() => {
          var _el$99 = _tmpl$8();
          _$insert(_el$99, () => fmtDt(r().updated_dt));
          return _el$99;
        })()];
      }
    }), null);
    _$insert(_el$88, _$createComponent(Show, {
      get when() {
        return r().import_user_id;
      },
      get children() {
        return [(() => {
          var _el$100 = _tmpl$7();
          _$insert(_el$100, () => tr('import_user_id'));
          return _el$100;
        })(), (() => {
          var _el$101 = _tmpl$8();
          _$insert(_el$101, () => userName(r().import_user_id), null);
          _$insert(_el$101, (() => {
            var _c$2 = _$memo(() => !!r().import_app_id);
            return () => _c$2() ? ` (${r().import_app_id})` : '';
          })(), null);
          return _el$101;
        })()];
      }
    }), null);
    return _el$88;
  })(), _$createComponent(Show, {
    get when() {
      return props.logs.length > 0;
    },
    get fallback() {
      return (() => {
        var _el$103 = _tmpl$24();
        _$insert(_el$103, () => tr('detail.NoLogs'));
        return _el$103;
      })();
    },
    get children() {
      var _el$102 = _tmpl$23();
      _$insert(_el$102, _$createComponent(For, {
        get each() {
          return props.logs;
        },
        children: log => (() => {
          var _el$104 = _tmpl$26(),
            _el$105 = _el$104.firstChild,
            _el$106 = _el$105.firstChild,
            _el$107 = _el$106.nextSibling,
            _el$108 = _el$107.nextSibling,
            _el$109 = _el$105.nextSibling;
          _$insert(_el$106, () => tr(`action.${log.log_action}`));
          _$insert(_el$107, () => fmtDt(log.log_dt));
          _$insert(_el$108, () => log.log_login || userName(log.log_userid));
          _$insert(_el$109, _$createComponent(Show, {
            get when() {
              return log.log_state1 !== log.log_state2;
            },
            get children() {
              var _el$110 = _tmpl$25(),
                _el$111 = _el$110.firstChild,
                _el$114 = _el$111.nextSibling,
                _el$112 = _el$114.nextSibling,
                _el$113 = _el$112.nextSibling;
              _$insert(_el$110, () => tr('state'), _el$111);
              _$insert(_el$110, (() => {
                var _c$3 = _$memo(() => !!log.log_state1);
                return () => _c$3() ? tr(`state.${log.log_state1}`) : '—';
              })(), _el$114);
              _$insert(_el$113, () => tr(`state.${log.log_state2}`));
              return _el$110;
            }
          }), null);
          _$insert(_el$109, _$createComponent(Show, {
            get when() {
              return changes(log).length > 0;
            },
            get fallback() {
              return _$createComponent(Show, {
                get when() {
                  return log.log_state1 === log.log_state2;
                },
                get children() {
                  var _el$115 = _tmpl$27();
                  _$insert(_el$115, () => tr('detail.NoChanges'));
                  return _el$115;
                }
              });
            },
            get children() {
              return _$createComponent(For, {
                get each() {
                  return changes(log);
                },
                children: ([label, value]) => (() => {
                  var _el$116 = _tmpl$28(),
                    _el$117 = _el$116.firstChild,
                    _el$120 = _el$117.nextSibling,
                    _el$118 = _el$120.nextSibling,
                    _el$119 = _el$118.nextSibling;
                  _$insert(_el$116, label, _el$120);
                  _$insert(_el$119, value);
                  return _el$116;
                })()
              });
            }
          }), null);
          _$effect(() => _$className(_el$104, `tzr-log ${dotClass(log)}`));
          return _el$104;
        })()
      }));
      return _el$102;
    }
  })];
}
_$delegateEvents(["click"]);